import ProjectCard from './ProjectCard'
import './ProjectCard.scss'

export default ProjectCard
